import { Spinner } from "@chakra-ui/react"
import React, { Suspense } from "react"

const StandaloneSpaceSignupFlowContainer = React.lazy(
  () =>
    import(
      "./StandaloneSpaceSignupFlowContainer" /* webpackChunkName: "StandaloneSpaceSignupFlowContainer" */
    )
)

function LazyStandaloneSpaceSignupFlowContainer(props: any) {
  return (
    <Suspense fallback={<Spinner />}>
      <StandaloneSpaceSignupFlowContainer {...props} />
    </Suspense>
  )
}

export default LazyStandaloneSpaceSignupFlowContainer
